
import sortTabsAutocomplete from './sort';

// tabs = [{
// 	label,
// 	id, // country id
// 	... // any data
// 	tree: [{
// 		label,
// 		... // any data
// 		children,
// 	}],
// }]

const getRegionsTabsAutocomplete = geoData => {
	const countriesMap = {}
	const parentStationsMap = {}
	const parentStationsTreeMap = {}
	geoData.stations.forEach(station => {
		if (station.id === '' || station.id == null) return;
		if(!countriesMap[station.countryId]){
			const country = geoData.countries?.find(({id}) => id === station.countryId);
			if (!country) return;
			countriesMap[country.id] = {
				label: country.label,
				id: country.id,
				tree: [],
			}
		}
		if(station.parentStationId){
			if(!parentStationsMap[station.parentStationId]){
				const parentStation = geoData.parentStations.find(({id}) => id === station.parentStationId);

				if(!parentStation) {
					return 
				}
				
				parentStationsMap[station.parentStationId] = parentStation;
				parentStationsTreeMap[station.parentStationId] = [];
				countriesMap[station.countryId].tree.push({
					label: parentStation.label,
					id: parentStation.id,
					children: parentStationsTreeMap[station.parentStationId],
					isParentStation: true,
				});
			}
			parentStationsTreeMap[station.parentStationId].push({
				label: station.label,
				id: station.id,
				isStation: true,
			});
		}else{
			countriesMap[station.countryId].tree.push({
				label: station.label,
				id: station.id,
				isStation: true,
			});
		}
	});
	const countries = Object.values(countriesMap);
	sortTabsAutocomplete(countries, {tabsFirstFR: true});
	return countries;
}
export default getRegionsTabsAutocomplete;